
import React from 'react';

class Footer extends React.Component {

  render() {
    return (
      <div style = {{
        marginTop: '100px',
        textAlign: 'center',
        backgroundColor: '#999999',
        color: 'white',
        padding: '100px 0 30px 0'
      }}>
        <img
          style = {{height: '30px'}}
          src = {require('../icons/contact_blue.png')}
        />
        <div style = {{
          fontSize: '20px'
        }}>
          Manó Szentesi
        </div>
        <div
          style = {{
          margin: '30px 0 150px 0',
          fontSize: '14px'
        }}>
          <span style={{whiteSpace: 'nowrap'}}>
            <img
              style = {{height: '26px', verticalAlign: 'middle', margin: '10px'}}
              src = {require('../icons/mobile_blue.png')}
            />
            +36 30 94 89 408
          </span>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          <span style={{whiteSpace: 'nowrap'}}>
            <img
              style = {{height: '16px', verticalAlign: 'middle', margin: '10px'}}
              src = {require('../icons/mail_blue.png')}
            />
            mano@manodesign.hu
          </span>
        </div>
        <img
          style = {{width: '160px'}}
          src = {require('../icons/footer_mano_text.png')}
        />

      </div>
    );
  }
}

export default Footer;





// WEBPACK FOOTER //
// ./src/components/Footer.js